module.exports = __webpack_public_path__ + "img/icon_mail_forwarding.e6fde417.svg";